import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Naming the Wound",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I stop blurring it. Something in me was hurt — and I’m willing to acknowledge it."
    ],
      [
      "Daily intention: Today I stop blurring it. Something in me was hurt — and I’m willing to acknowledge it."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One slow breath.",
      "I tell myself quietly: “If it hurts, there is a reason.”"
    ],
      [
      "I pause with myself.",
      "One slow breath.",
      "I tell myself quietly: “If it hurts, there is a reason.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What exactly happened that caused my trust to crack?",
      "What is the first emotion that comes up when I remember it?",
      "What is the hardest thing for me to admit was hurt in me?"
    ],
      [
      "What exactly happened that caused my trust to crack?",
      "What is the first emotion that comes up when I remember it?",
      "What is the hardest thing for me to admit was hurt in me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Today I don’t exaggerate and I don’t minimize. I acknowledge the wound."
    ],
      [
      "Closing",
      "Today I don’t exaggerate and I don’t minimize. I acknowledge the wound."
    ]
    ),
    action: localizedGenderNode(
      "Once today — hand on chest + breath + the sentence: “I’m allowed to feel this.”",
      "Once today — hand on chest + breath + the sentence: “I’m allowed to feel this.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Shock and Confusion",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I allow confusion without demanding clarity from myself."
    ],
      [
      "Daily intention: Today I allow confusion without demanding clarity from myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “Confusion is a response to injury.”"
    ],
      [
      "I pause with myself.",
      "One breath. “Confusion is a response to injury.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What changed in me after I discovered the truth?",
      "What thoughts keep looping again and again?",
      "Where in my body do I feel the instability?"
    ],
      [
      "What changed in me after I discovered the truth?",
      "What thoughts keep looping again and again?",
      "Where in my body do I feel the instability?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Confusion doesn’t mean I’m weak. It means something shifted."
    ],
      [
      "Closing",
      "Confusion doesn’t mean I’m weak. It means something shifted."
    ]
    ),
    action: localizedGenderNode(
      "10 minutes without screens — just being.",
      "10 minutes without screens — just being."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "The Crack in Trust",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I look at broken trust without blaming myself."
    ],
      [
      "Daily intention: Today I look at broken trust without blaming myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I rely on — and what broke?",
      "What happens to me when I’m no longer sure?",
      "Which part of me is trying to protect itself now?"
    ],
      [
      "What did I rely on — and what broke?",
      "What happens to me when I’m no longer sure?",
      "Which part of me is trying to protect itself now?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Trust is a foundation. When it cracks, the body reacts."
    ],
      [
      "Closing",
      "Trust is a foundation. When it cracks, the body reacts."
    ]
    ),
    action: localizedGenderNode(
      "Write one word that describes the crack — and close the notebook.",
      "Write one word that describes the crack — and close the notebook."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Questions Without Answers",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I meet the need to know — without getting pulled under."
    ],
      [
      "Daily intention: Today I meet the need to know — without getting pulled under."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “Not every question needs an answer today.”"
    ],
      [
      "I pause with myself.",
      "One breath. “Not every question needs an answer today.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Which question is chasing me the most?",
      "What do I hope will happen if I know everything?",
      "How does my body feel when I search for answers?"
    ],
      [
      "Which question is chasing me the most?",
      "What do I hope will happen if I know everything?",
      "How does my body feel when I search for answers?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Sometimes quiet matters more than the full truth."
    ],
      [
      "Closing",
      "Sometimes quiet matters more than the full truth."
    ]
    ),
    action: localizedGenderNode(
      "A 30-second pause before any checking or investigating.",
      "A 30-second pause before any checking or investigating."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Anger",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I give anger space without destroying myself."
    ],
      [
      "Daily intention: Today I give anger space without destroying myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “I’m allowed to be angry.”"
    ],
      [
      "I pause with myself.",
      "One breath. “I’m allowed to be angry.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is my anger really about?",
      "What boundary is my anger trying to restore?",
      "How can I release anger without harming myself?"
    ],
      [
      "What is my anger really about?",
      "What boundary is my anger trying to restore?",
      "How can I release anger without harming myself?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Anger is energy — not a verdict."
    ],
      [
      "Closing",
      "Anger is energy — not a verdict."
    ]
    ),
    action: localizedGenderNode(
      "10 minutes of movement (walk / stretch).",
      "10 minutes of movement (walk / stretch)."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Shame and Comparison",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I separate injury from self-worth."
    ],
      [
      "Daily intention: Today I separate injury from self-worth."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What shaming sentence comes up in me?",
      "Who am I comparing myself to?",
      "What gentle truth exists about me even now?"
    ],
      [
      "What shaming sentence comes up in me?",
      "Who am I comparing myself to?",
      "What gentle truth exists about me even now?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Being hurt does not define who I am."
    ],
      [
      "Closing",
      "Being hurt does not define who I am."
    ]
    ),
    action: localizedGenderNode(
      "Write one quality in me that did not disappear.",
      "Write one quality in me that did not disappear."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "The Body Remembers",
    opening: localizedGenderNode(
      [
      "Daily intention: My body tells a story — and I listen."
    ],
      [
      "Daily intention: My body tells a story — and I listen."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "A slow breath."
    ],
      [
      "I pause with myself.",
      "A slow breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "How does my body react when I’m near my partner?",
      "How does my body react when I’m alone?",
      "What’s the difference?"
    ],
      [
      "How does my body react when I’m near my partner?",
      "How does my body react when I’m alone?",
      "What’s the difference?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "The body is a signal, not an enemy."
    ],
      [
      "Closing",
      "The body is a signal, not an enemy."
    ]
    ),
    action: localizedGenderNode(
      "Hand on body + breath when a trigger appears.",
      "Hand on body + breath when a trigger appears."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Fear of Being Hurt Again",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I recognize fear without letting it take control."
    ],
      [
      "Daily intention: Today I recognize fear without letting it take control."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What am I most afraid will happen again?",
      "What do I do to prevent pain?",
      "Does it really protect me?"
    ],
      [
      "What am I most afraid will happen again?",
      "What do I do to prevent pain?",
      "Does it really protect me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Fear tries to protect — sometimes at a high cost."
    ],
      [
      "Closing",
      "Fear tries to protect — sometimes at a high cost."
    ]
    ),
    action: localizedGenderNode(
      "Write one fear and place a period after it.",
      "Write one fear and place a period after it."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Boundaries",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I check what I need to feel safe."
    ],
      [
      "Daily intention: Today I check what I need to feel safe."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Which boundary is missing for me right now?",
      "What scares me about setting it?",
      "How does a boundary look without threat?"
    ],
      [
      "Which boundary is missing for me right now?",
      "What scares me about setting it?",
      "How does a boundary look without threat?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "A boundary protects the heart."
    ],
      [
      "Closing",
      "A boundary protects the heart."
    ]
    ),
    action: localizedGenderNode(
      "Formulate one inner boundary.",
      "Formulate one inner boundary."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Can Trust Be Rebuilt",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I don’t decide — I only explore the possibility."
    ],
      [
      "Daily intention: Today I don’t decide — I only explore the possibility."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What would I need to see for trust to return?",
      "What has already happened that unsettles me?",
      "What does my body say about this possibility?"
    ],
      [
      "What would I need to see for trust to return?",
      "What has already happened that unsettles me?",
      "What does my body say about this possibility?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Possibility is not commitment."
    ],
      [
      "Closing",
      "Possibility is not commitment."
    ]
    ),
    action: localizedGenderNode(
      "No decisions today.",
      "No decisions today."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "My Responsibility",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I examine my part — without blame."
    ],
      [
      "Daily intention: Today I examine my part — without blame."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is truly my responsibility?",
      "What is not?",
      "How does responsibility look without self-punishment?"
    ],
      [
      "What is truly my responsibility?",
      "What is not?",
      "How does responsibility look without self-punishment?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Responsibility does not require pain."
    ],
      [
      "Closing",
      "Responsibility does not require pain."
    ]
    ),
    action: localizedGenderNode(
      "One gentle responsibility sentence to myself.",
      "One gentle responsibility sentence to myself."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Who I Am Now",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I meet myself after the injury."
    ],
      [
      "Daily intention: Today I meet myself after the injury."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What changed in me?",
      "What strengthened in me despite everything?",
      "What do I need most right now?"
    ],
      [
      "What changed in me?",
      "What strengthened in me despite everything?",
      "What do I need most right now?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "I am still here."
    ],
      [
      "Closing",
      "I am still here."
    ]
    ),
    action: localizedGenderNode(
      "One action that reminds me who I am.",
      "One action that reminds me who I am."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Looking Forward",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I look ahead with gentleness."
    ],
      [
      "Daily intention: Today I look ahead with gentleness."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What kind of relationship do I want in the future?",
      "Which value will I no longer give up?",
      "What is one small step in that direction?"
    ],
      [
      "What kind of relationship do I want in the future?",
      "Which value will I no longer give up?",
      "What is one small step in that direction?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "The future is built with quiet steps."
    ],
      [
      "Closing",
      "The future is built with quiet steps."
    ]
    ),
    action: localizedGenderNode(
      "Write one value and keep it with me.",
      "Write one value and keep it with me."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Gentle Closure",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I don’t erase what happened — I choose how to continue."
    ],
      [
      "Daily intention: Today I don’t erase what happened — I choose how to continue."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One deep breath."
    ],
      [
      "I pause with myself.",
      "One deep breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What am I releasing to protect my heart?",
      "What am I taking with me from this journey?",
      "A return sentence for difficult days:"
    ],
      [
      "What am I releasing to protect my heart?",
      "What am I taking with me from this journey?",
      "A return sentence for difficult days:"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Final closure of the journey",
      "My trust was hurt — but I did not disappear.",
      "I am learning to listen to myself,",
      "and to choose a relationship that doesn’t require me to shrink my heart.",
      "And that is strength."
    ],
      [
      "Final closure of the journey",
      "My trust was hurt — but I did not disappear.",
      "I am learning to listen to myself,",
      "and to choose a relationship that doesn’t require me to shrink my heart.",
      "And that is strength."
    ]
    ),
    action: localizedGenderNode(
      "One action that symbolizes loyalty to myself.",
      "One action that symbolizes loyalty to myself."
    ),
  },
].map(buildNormalizedDay);

export const lackOfTrustInRelationshipBlueprintEn = buildNormalizedPilotBlueprint({
  id: "lack_of_trust_in_relationship_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "lack_of_trust_in_relationship",
  category: "general",
  journeyName: {
    he: "חוסר אמון בזוגיות (בגידה, שקרים, סודות)",
    en: "Lack of Trust in a Relationship (Betrayal, Lies, Secrets)",
    es: "Falta de confianza en la relación (engaño, mentiras, secretos)",
  },
  days,
});

export default lackOfTrustInRelationshipBlueprintEn;
